import { toast } from 'sonner';
import { useMutation } from '@apollo/client/react';

import { ToggleGroupCard, ToggleGroupCardItem } from '@/components/ui/toggle-group';
import { AgreementUpdateDocument } from 'src/graphql/actions/agreement/agreementUpdate.mutation';
import { ClientError, getApiError } from 'src/utils/errors';

import { agreementTemplateOptionsRich } from '../model';

type Props = {
  escrowId: string;
  isThirdPartyAgreement: boolean;
};

const AgreementTemplateSettings = ({ escrowId, isThirdPartyAgreement }: Props) => {
  const [updateAgreement] = useMutation(AgreementUpdateDocument);

  const onUpdateAgreement = async (thirdPartyAgreement: string) => {
    if (thirdPartyAgreement === '') return;

    try {
      const { data } = await updateAgreement({
        variables: {
          escrowId,
          agreementParams: {
            thirdPartyAgreement: thirdPartyAgreement === 'true',
          },
        },
      });

      if (data?.agreementUpdate?.success) {
        toast.success('Saved!');
      } else {
        throw new ClientError(data?.agreementUpdate?.errors?.[0]);
      }
    } catch (error: unknown) {
      getApiError(error, toast.error);
    }
  };

  return (
    <ToggleGroupCard
      type="single"
      orientation="horizontal"
      onValueChange={onUpdateAgreement}
      value={isThirdPartyAgreement ? 'true' : 'false'}
    >
      {agreementTemplateOptionsRich.map(({ value, icon: Icon, label, description }) => (
        <ToggleGroupCardItem key={value} value={value} icon={Icon} title={label} description={description} />
      ))}
    </ToggleGroupCard>
  );
};

export default AgreementTemplateSettings;
